export default "__VITE_ASSET__DkhuXRcW__"